import React from 'react';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/config';

// ✅ Any fun GIF – you can replace this with your own
const WELCOME_GIF = 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMnJreWtsMzR0NW9uaDF0azFxZm9jcG9pdG14Zm1pZDRnc3B6eHc1eSZlcD12MV9naWZzX3NlYXJjaCZjdD1n/VhWVAa7rUtT3xKX6Cd/giphy.gif';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/');
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
     
      <img
        src={WELCOME_GIF}
        alt="Welcome"
        style={{ width: '100%', maxWidth: '400px', marginBottom: '20px' }}
      />

      <h1>UYYYYYYY!</h1>
      <p>Welcome to your KUPAL!</p>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default Dashboard;
